<template>
  <FriedModal @close="$emit('close')">
    <template #header>
      <FriedModalHeader :header="t('dr_delete_message')" />
    </template>
    <div>
      <FriedParagraph class="delete-message-text" :size="ParagraphSize.Large">
        {{ t('dr_delete_message_confirmation') }}
      </FriedParagraph>
      <ChatMessageContent
        class="chat-message-content"
        :participants="participants"
        :message="message"
        :messages="messages"
        :current-chat-participant="currentChatParticipant"
        :locale="locale"
        view-only
      />
    </div>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          data-external="delete-chat-message-cancel-button"
          :button-type="ButtonType.Secondary"
          @click="$emit('close')"
        >
          {{ t('cancel') }}
        </FriedButton>
        <FriedButton
          data-external="delete-chat-message-confirm-button"
          @click="$emit('confirm', message.id)"
          >{{ t('dr_delete_message') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { ButtonType, ParagraphSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import type { Message, ChatParticipant } from '../types';
import type { Participant } from '../../types';
import ChatMessageContent from './ChatMessageContent.vue';

export default defineComponent({
  components: {
    ChatMessageContent,
  },
  props: {
    participants: {
      type: Array as PropType<Array<Participant>>,
      required: true,
    },
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
    messages: {
      type: Array as PropType<Array<Message>>,
      required: true,
    },
    currentChatParticipant: {
      type: Object as PropType<ChatParticipant>,
      default: undefined as ChatParticipant,
    },
    locale: {
      type: String,
      default: 'en-US',
    },
  },
  emits: ['close', 'confirm'],
  setup() {
    const { t } = useI18n();
    return {
      ButtonType,
      ParagraphSize,
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.delete-message-text {
  padding-bottom: var(--spacing-200);
}

.chat-message-content {
  display: flex;
  justify-content: flex-end;
}
</style>
